import { jobRoles } from "@/pages/Preferences/constants";

export const getFilteredPreferences = (preferenceType: string, preferences?: string[]) => {
    if (!preferences) return [];
    if (preferenceType === "jobRoles") {
        return preferences?.filter(role => jobRoles.some(jobRole => jobRole.value === role)) || [];
    }
    return [];
};
